import { cn, getButtonVariant } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';
import { Button } from '@workspace/ui/common/Buttons/Button';
import { Typography } from '@workspace/ui/common/Typography/Typography';
import { ProductTypeButton } from '../product-type.types';

interface ProductTypeHeaderProps {
  title: string;
  alignmentClass: string;
  buttons: ProductTypeButton[];
  getButtonUrl: (button: ProductTypeButton) => string;
  getOpenInNewTab: (button: ProductTypeButton) => boolean;
}

export function ProductTypeHeader({
  title,
  alignmentClass,
  buttons,
  getButtonUrl,
  getOpenInNewTab,
}: ProductTypeHeaderProps) {
  return (
    <div className="flex lg:gap-4 md:items-center md:flex-row md:justify-between md:mb-12 mb-8 flex-col justify-center">
      <Typography
        variant="h3"
        className={`${alignmentClass} self-start md:w-auto wrap-break-word whitespace-normal md:break-normal md:font-bold`}
      >
        {title}
      </Typography>

      {buttons.length > 0 && (
        <div
          className={cn(
            'md:flex md:w-fit md:flex-wrap md:gap-3  md:pt-0 justify-end',
            buttons.length > 0 ? 'pt-8' : 'pt-0',
          )}
        >
          {buttons.map((button, idx) => {
            const label = stripInvisibles(button.label || 'Learn more').trim() || 'Learn more';
            return (
              <Button
                key={button?._key ?? `pt-btn-${idx}`}
                variant={getButtonVariant(button.style)}
                className="mb-2 last:mb-0 md:mb-0 max-md:w-full! max-md:max-w-none"
                openInNewTab={getOpenInNewTab(button)}
                url={getButtonUrl(button)}
              >
                {label}
              </Button>
            );
          })}
        </div>
      )}
    </div>
  );
}
